module.exports = __webpack_public_path__ + "img/CompanyCoursesIcon.6f9eed2c.svg";